export default __webpack_public_path__ + "static/media/190629_190332_The Big One December 2018.f1bc6e30.jpg";